import { falsyToUndefined } from "../../../../../../lib/lang"
import { CreateUser, UpdateUser, User } from "../../../../../users/userTypes"

import { TenantUserFormValues } from "../tenantUserTypes"

type TenantContext = Readonly<{
    companyId: number
    userGroupId: number
}>

export function toTenantUserFormValues(user: User): TenantUserFormValues {
    return {
        username: user.username ?? "",
        employeeId: user.employeeId ?? "",
        displayName: user.displayName ?? "",
        email: user.email ?? "",
        mobileNumber: user.mobileNumber ?? "",
        phoneNumber: user.phoneNumber ?? "",
        sendEmailInvitation: true,
        ignoreUserSyncJobs: user.settings?.ignoreUserSyncJobs ?? false,
        isActive: user.isActive ?? true,
        workgroups: user.workgroups ?? [],
    }
}

export function toCreateTenantUserBody(
    values: TenantUserFormValues,
    { companyId, userGroupId }: TenantContext,
): CreateUser {
    return {
        companyId,
        customerTypeId: userGroupId,

        employeeId: falsyToUndefined(values.employeeId),
        displayName: values.displayName,
        email: values.email,
        mobileNumber: falsyToUndefined(values.mobileNumber),
        phoneNumber: falsyToUndefined(values.phoneNumber),

        settings: {
            sendEmailInvitation: values.sendEmailInvitation,
            ignoreUserSyncJobs: values.ignoreUserSyncJobs,
        },
        workgroups: values.workgroups.map((workgroup) => ({ id: workgroup.id })),
    }
}

/**
 * `companyId`, `customerTypeId` and `username` are not editable in the form, so they are carried over from the
 * user we loaded — the update endpoint expects the full object, not a patch.
 */
export function toUpdateTenantUserBody(values: TenantUserFormValues, existingUser: User): UpdateUser {
    return {
        companyId: existingUser.companyId,
        customerTypeId: existingUser.customerTypeId,
        username: existingUser.username,

        employeeId: values.employeeId,
        displayName: values.displayName,
        email: values.email,
        mobileNumber: values.mobileNumber,
        phoneNumber: values.phoneNumber,

        settings: {
            ignoreUserSyncJobs: values.ignoreUserSyncJobs,
        },
        isActive: values.isActive,
        workgroups: values.workgroups.map((workgroup) => ({ id: workgroup.id })),
    }
}
